import PageSection from '@sayyesschool/frontend/components/page-section';
import { useSetting } from '@sayyesschool/frontend/features/settings';
import { Flex } from '@sayyesschool/frontend/ui-components';

import SettingForm from '@/components/settings/setting-form';

export default function SettingSection({ name, title }) {
    const [setting = {}, set] = useSetting(name);

    const create = (data, form) => {
        set({
            ...setting,
            [data.get('key')]: data.get('value')
        });

        form.reset();
    };

    const update = (data, form) => {
        delete setting[form.name];

        set({
            ...setting,
            [data.get('key')]: data.get('value')
        });
    };

    return (
        <PageSection title={title}>
            <Flex
                dir="column"
                gap="s"
            >
                {Object.entries(setting).map(([key, value]) =>
                    <SettingForm
                        key={key}
                        name={key}
                        data={{ key, value }}
                        buttonContent="Сохранить"
                        onSubmit={update}
                    />
                )}

                <SettingForm
                    buttonContent="Добавить"
                    onSubmit={create}
                />
            </Flex>
        </PageSection>
    );
}